export const tableHeader = {
  'Order no.': 'orderNo',
  'From': 'from',
  'To': 'to',
  'Floor area': 'floorArea',
  'Weight': 'weight',
  'Status': 'status',
};
